import { createReducer } from '@reduxjs/toolkit';

import { CommonInfoStateType } from '../../types';
import {
  getAvailablePaymentTokens,
  getPaymentTokens,
  getPaymentTypes,
} from '../actions/common-info';

const initialState: CommonInfoStateType = {
  paymentTypes: [],
  paymentTokens: [],
  availablePaymentTokens: [],
};

const commonInfoReducer = createReducer(initialState, (builder) => {
  builder.addCase(getPaymentTypes.fulfilled, (state, action) => {
    if (action.payload) {
      state.paymentTypes = action.payload;
    }
  });
  builder.addCase(getPaymentTokens.fulfilled, (state, action) => {
    if (action.payload) {
      state.paymentTokens = action.payload;
    }
  });
  builder.addCase(getAvailablePaymentTokens.fulfilled, (state, action) => {
    if (action.payload) {
      state.availablePaymentTokens = action.payload;
    }
  });
});

export default commonInfoReducer;
